import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./homepage-brand-value.css";

interface JoinItemProps {
    paragraph: string;
    joinUrl: string;
}

export function JoinItem({ paragraph, joinUrl }: JoinItemProps): JSX.Element {
    return (
        <a href={joinUrl}>
            <div className={styles.joinItem}>
                <p className={styles.joinParagraph}>{paragraph}</p>
                <span className={styles.joinUrl}>
                    {gettext("homepage.module_value_props_join_button") // Join
                    }
                    <SVGIcon className={styles.arrowIcon} name={"arrow-icon"} />
                </span>
            </div>
        </a>
    );
}

interface StartShoppingItemProps {
    url: string;
    ctaText: string;
}

export function StartShoppingItem({ url, ctaText }: StartShoppingItemProps): JSX.Element {
    return (
        <a href={url}>
            <div className={styles.joinItem}>
                <div className={styles.startShoppingUrl}>
                    {ctaText}
                    <SVGIcon className={styles.arrowIcon} name={"arrow-icon"} />
                </div>
            </div>
        </a>
    );
}

interface HomepageBrandValueItem {
    title: string;
    paragraphs: string[];
}

interface HomepageBrandValueItemProps {
    value: HomepageBrandValueItem;
    numeral: number;
}

export function HomepageBrandValueItem({
    value,
    numeral,
}: HomepageBrandValueItemProps): JSX.Element {
    return (
        <li className={styles.homepageBrandValueItem}>
            <h2 className={styles.numeral}> {numeral} </h2>
            <h4 className={styles.title}> {value.title} </h4>
            {value.paragraphs.map((paragraph) => (
                <p key={paragraph} className={styles.paragraph}>
                    {paragraph}
                </p>
            ))}
        </li>
    );
}

export interface HomepageBrandValueProps {
    items: HomepageBrandValueItem[];
    join_paragraph: string;
    join_url: string;
    start_shopping_cta_text?: string;
    start_shopping_url?: string;
}

function HomepageBrandValue({
    items,
    join_paragraph: joinParagraph,
    join_url: joinUrl,
    start_shopping_cta_text: startShoppingCtaText = "",
    start_shopping_url: startShoppingUrl = "",
}: HomepageBrandValueProps): JSX.Element {
    return (
        <div className={styles.homepageBrandValueWrapper}>
            <div className={styles.valuesContainer}>
                <ul className={styles.homepageBrandValuesList}>
                    {items.map((value, index) => (
                        <HomepageBrandValueItem
                            key={value.title}
                            value={value}
                            numeral={index + 1}
                        />
                    ))}
                </ul>
            </div>
            <div className={styles.actionContainer}>
                {startShoppingUrl ? (
                    <StartShoppingItem ctaText={startShoppingCtaText} url={startShoppingUrl} />
                ) : (
                    <JoinItem paragraph={joinParagraph} joinUrl={joinUrl} />
                )}
            </div>
        </div>
    );
}

export default HomepageBrandValue;
